import DOMPurify from 'isomorphic-dompurify';

export function sanitizeProductDescription(description: string): string {
  return DOMPurify.sanitize(description, { USE_PROFILES: { html: true } });
}
